export default "__VITE_ASSET__tX5QG1Vn__"